<template>
  <div style='width: 200px;height: 200px;' class='eleadButton'>
		123111
	</div>
</template>
<script setup lang='ts' name='eleadButton'>

</script>
<style scoped lang='less'>
   @import "eleadButton.less";
   .eleadButton{
     background: #181818;
   }
</style>
